import { Emitter, now } from "@welshman/lib";
import { subscribe, publish, SubscriptionEvent } from "@welshman/net";
export var DVMEvent;
(function (DVMEvent) {
    DVMEvent["Progress"] = "progress";
    DVMEvent["Result"] = "result";
})(DVMEvent || (DVMEvent = {}));
export const makeDvmRequest = (request) => {
    const emitter = new Emitter();
    const { event, relays, timeout = 30_000, autoClose = true, reportProgress = true } = request;
    const kind = event.kind + 1000;
    const kinds = reportProgress ? [kind, 7000] : [kind];
    const filters = [{ kinds, since: now() - 60, "#e": [event.id] }];
    const sub = subscribe({ relays, timeout, filters });
    const pub = publish({ event, relays, timeout });
    sub.on(SubscriptionEvent.Event, (url, event) => {
        if (event.kind === 7000) {
            emitter.emit(DVMEvent.Progress, url, event);
        }
        else {
            emitter.emit(DVMEvent.Result, url, event);
            if (autoClose) {
                sub.close();
            }
        }
    });
    return { request, emitter, sub, pub };
};
//# sourceMappingURL=request.js.map